<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">System Banners</span>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#systemBannersNavbar"
      aria-controls="systemBannersNavbar"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="systemBannersNavbar">
      <span class="mr-auto">
        <button
          type="button"
          mat-raised-button
          class="m-1 mr-2"
          color="primary"
          (click)="onAdd()">
          <mat-icon>add</mat-icon> Create New Banner
        </button>

        <!-- Bulk actions menu (only shown when at least one row is selected) -->
        <ng-container *ngIf="dataSource.selection.selected.length > 0">
          <button
            type="button"
            mat-stroked-button
            class="m-1 mr-2"
            [matMenuTriggerFor]="bulkActionsMenu">
            <mat-icon>checklist</mat-icon>
            Bulk Actions ({{ dataSource.selection.selected.length }})
          </button>
          <mat-menu #bulkActionsMenu="matMenu">
            <button type="button" mat-menu-item (click)="onBulkPublish()">
              <mat-icon>publish</mat-icon>
              <span>Publish Selected</span>
            </button>
            <button type="button" mat-menu-item (click)="onBulkArchive()">
              <mat-icon>archive</mat-icon>
              <span>Archive Selected</span>
            </button>
            <button type="button" mat-menu-item (click)="onBulkRestore()">
              <mat-icon>restore</mat-icon>
              <span>Restore Selected</span>
            </button>
            <button type="button" mat-menu-item (click)="onBulkDelete()">
              <mat-icon>delete</mat-icon>
              <span>Delete Selected</span>
            </button>
          </mat-menu>
        </ng-container>
      </span>
    </div>
  </nav>

  <!-- Status filter tabs -->
  <mat-tab-group
    class="bg-white"
    [selectedIndex]="0"
    (selectedIndexChange)="onStatusFilterChange($event)">
    <mat-tab *ngFor="let option of statusFilterOptions" [label]="option.label"></mat-tab>
  </mat-tab-group>

  <!-- Loading indicator -->
  <div class="text-center p-2" *ngIf="(dataSource.loading | async)">
    <mat-icon class="spin-icon align-middle mr-2">autorenew</mat-icon>
    <span class="align-middle">Loading banners...</span>
  </div>

  <div class="mat-elevation-z8 scroll-box">
    <mat-paginator
      #paginator1
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons></mat-paginator>

    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="sort_order"
      matSortDirection="asc"
      matSortDisableClear>

      <caption class="px-3">This is a list of all system banners. Banners are displayed to users in ascending sort order.</caption>

      <!-- Selection checkbox -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef id="th-select" [style.width.px]="56">
          <mat-checkbox
            (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && isAllPageSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !isAllPageSelected()"
            matTooltip="Select all on this page">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let banner">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(banner.id) : null"
            [checked]="dataSource.selection.isSelected(banner.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Reorder buttons -->
      <ng-container matColumnDef="reorder">
        <th mat-header-cell *matHeaderCellDef id="th-reorder" [style.width.px]="100">Order</th>
        <td mat-cell *matCellDef="let banner; let i = index">
          <div class="reorder-buttons" *ngIf="banner.status !== 'archived'; else noReorder">
            <button
              type="button"
              mat-icon-button
              class="reorder-button"
              matTooltip="Move up"
              [disabled]="i === 0"
              (click)="onMoveUp(i)">
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button
              type="button"
              mat-icon-button
              class="reorder-button"
              matTooltip="Move down"
              [disabled]="isLastRow(i)"
              (click)="onMoveDown(i)">
              <mat-icon>arrow_downward</mat-icon>
            </button>
          </div>
          <ng-template #noReorder>
            <span class="text-muted">N/A</span>
          </ng-template>
        </td>
      </ng-container>

      <!-- Content (truncated preview) -->
      <ng-container matColumnDef="content">
        <th mat-header-cell *matHeaderCellDef id="th-content" [style.width.px]="320" [style.max-width.px]="320">Content</th>
        <td mat-cell *matCellDef="let banner" class="content-cell">
          <span class="content-preview">
            {{ getContentPreview(banner.content) }}
          </span>
        </td>
      </ng-container>

      <!-- Style -->
      <ng-container matColumnDef="style">
        <th mat-header-cell *matHeaderCellDef id="th-style" [style.width.px]="110">Style</th>
        <td mat-cell *matCellDef="let banner">
          <span class="style-chip" [ngClass]="'style-chip-' + (banner.style || 'info')">
            {{ banner.style | titlecase }}
          </span>
        </td>
      </ng-container>

      <!-- Platforms -->
      <ng-container matColumnDef="platforms">
        <th mat-header-cell *matHeaderCellDef id="th-platforms" [style.width.px]="130">Platforms</th>
        <td mat-cell *matCellDef="let banner">
          <span
            *ngFor="let platform of getEnabledPlatforms(banner)"
            class="platform-icon"
            [class.platform-enabled]="platform.enabled"
            [class.platform-disabled]="!platform.enabled"
            [matTooltip]="platform.label + (platform.enabled ? ' (enabled)' : ' (disabled)')">
            <mat-icon>{{ platform.icon }}</mat-icon>
          </span>
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef id="th-status" [style.width.px]="110">Status</th>
        <td mat-cell *matCellDef="let banner">
          <span class="status-chip" [ngClass]="'status-chip-' + (banner.status || 'draft')">
            {{ banner.status | titlecase }}
          </span>
        </td>
      </ng-container>

      <!-- Starts At -->
      <ng-container matColumnDef="starts_at">
        <th mat-header-cell *matHeaderCellDef id="th-starts-at" [style.width.px]="180">Starts At</th>
        <td mat-cell *matCellDef="let banner">
          <span *ngIf="banner.starts_at; else noStart">{{ formatScheduleDate(banner.starts_at, banner.timezone) }}</span>
          <ng-template #noStart><span class="text-muted">Immediately</span></ng-template>
        </td>
      </ng-container>

      <!-- Ends At -->
      <ng-container matColumnDef="ends_at">
        <th mat-header-cell *matHeaderCellDef id="th-ends-at" [style.width.px]="180">Ends At</th>
        <td mat-cell *matCellDef="let banner">
          <span *ngIf="banner.ends_at; else noEnd">{{ formatScheduleDate(banner.ends_at, banner.timezone) }}</span>
          <ng-template #noEnd><span class="text-muted">No expiry</span></ng-template>
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef id="th-actions" [style.width.px]="80"></th>
        <td mat-cell *matCellDef="let banner">
          <button
            type="button"
            mat-icon-button
            [matMenuTriggerFor]="bannerActionsMenu"
            matTooltip="Banner actions">
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #bannerActionsMenu="matMenu">
            <button type="button" mat-menu-item (click)="onEdit(banner)">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button
              type="button"
              mat-menu-item
              *ngIf="banner.status === 'draft'"
              (click)="onPublish(banner)">
              <mat-icon>publish</mat-icon>
              <span>Publish</span>
            </button>
            <button
              type="button"
              mat-menu-item
              *ngIf="banner.status === 'published'"
              (click)="onArchive(banner)">
              <mat-icon>archive</mat-icon>
              <span>Archive</span>
            </button>
            <button
              type="button"
              mat-menu-item
              *ngIf="banner.status === 'archived'"
              (click)="onRestore(banner)">
              <mat-icon>restore</mat-icon>
              <span>Restore</span>
            </button>
            <button type="button" mat-menu-item (click)="onDelete(banner)">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <!-- Empty state -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center p-3" [attr.colspan]="displayedColumns.length">
          No banners found.
        </td>
      </tr>
    </table>

    <mat-paginator
      #paginator2
      [length]="dataSource?.total | async"
      [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions"
      showFirstLastButtons></mat-paginator>
  </div>
</div>
